import api from './client';

/**
 * Активная (незавершённая) сессия урока текущего ученика или null.
 * Отдельный ?active=1 — иначе пагинация /api/tasks/lesson-sessions/ может
 * не вернуть старую незакрытую сессию на первой странице.
 */
export async function fetchActiveLessonSession() {
  const res = await api.get('/tasks/lesson-sessions/', { params: { active: 1 } });
  const list = Array.isArray(res.data) ? res.data : res.data?.results || [];
  return list.find((s) => !s.ended_at) || null;
}
